interface IProps
  extends Omit<
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref'
  > {}
export function HighLight(props: IProps) {
  const { children, className } = props;

  return <div dangerouslySetInnerHTML={{ __html: children as string }} className={className} />;
}
